// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getText, getTimestamp
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
} from 'conversations-message-history/initial-message/operators/initialMessageGetters';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import SlottedMessage from '../slotted-message/SlottedMessage';
import { getTimestamp as getLegacyTimestamp, getType
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import AutomatedMessageAvatar from '../avatar/AutomatedMessageAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
const AutomatedMessageTitle = () => /*#__PURE__*/_jsx(Tooltip, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-message-history.initial-message.headerTooltip"
  }),
  children: /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.initial-message.header"
    })
  })
});
AutomatedMessageTitle.displayName = 'AutomatedMessageTitle';
const InitialMessage = ({
  message,
  positionDescriptors
}) => {
  const isLegacyInitialMessage = Boolean(getType(message));
  let timestamp;
  if (isLegacyInitialMessage) {
    timestamp = getLegacyTimestamp(message);
  } else {
    timestamp = getTimestamp(message);
  }
  return /*#__PURE__*/_jsx(SlottedMessage, {
    container: {
      componentProps: {
        positionDescriptors,
        use: AGENT,
        'data-test-id': 'primary-message-initial'
      }
    },
    avatar: {
      Component: AutomatedMessageAvatar
    },
    title: {
      Component: AutomatedMessageTitle
    },
    body: {
      componentProps: {
        contentText: getText(message)
      }
    },
    timestamp: {
      componentProps: {
        timestamp
      }
    }
  });
};
InitialMessage.displayName = 'InitialMessage';
InitialMessage.propTypes = {
  message: RecordPropType('InitialMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};
export default InitialMessage;